/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { Button, Typography } from 'antd';
import styled from 'styled-components';
import AddInput from '~/pages/wizard/services/cardOrderDetails/components/AddInput';

const getInitialTree = (treeListValues: any) => {
  // const [finalTreeData, setFinalTreeData] = useState([]);

  const nest = (items: any, uniqueId = null, link = 'parentId') =>
    items
      ?.filter((item: any) => item[link] === uniqueId)
      ?.map((item: any) => ({
        ...item,
        children: nest(items, item.uniqueId),
      }));

  return nest(treeListValues) ?? [];
};

export default getInitialTree;
